// Conviva uses the following webpage to maintain an allowlist. All other values are not displayed.
// https://en.wikipedia.org/wiki/Chromecast#Model_comparison
export var ChromecastModel;
(function (ChromecastModel) {
    ChromecastModel["ANDROID_RTM7"] = "Android TV - RTM7 built-in";
    ChromecastModel["ANDROID_RTT4"] = "Android TV - RTT4 built-in";
    ChromecastModel["ANDROID_TV"] = "Sabrina or Android TV with Chromecast built in";
    ChromecastModel["BEYONDTV5_PPR1"] = "Android TV - BeyondTV5 PPR1 built-in";
    ChromecastModel["BRAVIA_NRD91N"] = "Android TV - Sony Bravia NRD91N built-in";
    ChromecastModel["BRAVIA_OPR2"] = "Android TV - Sony Bravia OPR2 built-in";
    ChromecastModel["BRAVIA_OR_HISENSE_QTG3"] = "Android TV - Sony Bravia or Hisense QTG3 built-in";
    ChromecastModel["BRAVIA_PTT1"] = "Android TV - Sony Bravia PTT1 built-in";
    ChromecastModel["BRAVIA_RTK2"] = "Android TV - Sony Bravia RTK2 built-in";
    ChromecastModel["BRAVIA_RTT7"] = "Android TV - Sony Bravia RTT7 built-in";
    ChromecastModel["CASTABLE_TV_1"] = "Non-Android TV 1 with Chromecast built in";
    ChromecastModel["CASTABLE_TV_2"] = "Non-Android TV 2 with Chromecast built in";
    ChromecastModel["CASTABLE_TV_720P"] = "Non-Android TV 720p with Chromecast built in";
    ChromecastModel["GEN1"] = "Chromecast (1st generation)";
    ChromecastModel["GEN2"] = "Chromecast (2nd generation)";
    ChromecastModel["GEN3"] = "Chromecast (3rd generation)";
    ChromecastModel["HISENSE_PTMR"] = "Android TV - Hisense PTMR built-in";
    ChromecastModel["HISENSE_RTT2"] = "Android TV - Hisense RTT2 built-in";
    ChromecastModel["HOMATICS_RTT0"] = "Android TV - RTT0: Box R 4K Homatics";
    ChromecastModel["HOPPER_P129"] = "Android TV - Hopper Plus P129 built-in";
    ChromecastModel["LEAP2K_RTT0"] = "Android TV - RTT0: Leap L1 2K stick";
    ChromecastModel["LEAP4K_RTT0"] = "Android TV - RTT0: Leap S3 4K";
    ChromecastModel["MIBOX"] = "Android TV - Mi Box gen 1 - PI";
    ChromecastModel["MIBOX_GEN2_RTT0"] = "Android TV - Mi Box gen 2 - RTT0";
    ChromecastModel["NEST_HUB"] = "Google Nest Hub gen 1 or 2";
    ChromecastModel["NEST_HUB_MAX"] = "Google Nest Hub Max";
    ChromecastModel["ONN"] = "Android TV - Onn 2K stick or sti6140d360";
    ChromecastModel["PHILIPS_PTM5"] = "Android TV - Philips PTM5 built-in";
    ChromecastModel["PHILIPS_PTM6"] = "Android TV - Philips PTM6 built-in";
    ChromecastModel["PHILIPS_RTM6"] = "Android TV - Philips RTM6 built-in";
    ChromecastModel["PIXEL_TABLET"] = "Pixel Tablet";
    ChromecastModel["SKYWORTH_RTM5"] = "Android TV - Skyworth RTM5 built-in";
    ChromecastModel["TCL_RP1A"] = "Android TV - TCL RP1A built-in";
    ChromecastModel["TIVO_QTT8"] = "Android TV - Tivo QTT8 Stream 4K";
    ChromecastModel["TV_STREAMER"] = "Google TV Streamer";
    ChromecastModel["ULTRA"] = "Chromecast Ultra";
    ChromecastModel["UNKNOWN_1"] = "Unknown model 1";
    ChromecastModel["UNKNOWN_2"] = "Unknown model 2";
    ChromecastModel["UNKNOWN_720P"] = "Unknown model 720p max";
    ChromecastModel["UNKNOWN_ANDROID_TV_PRE12"] = "Android TV - Unknown pre-v12 built-in or dongle";
})(ChromecastModel || (ChromecastModel = {}));
export var ChromecastCodec;
(function (ChromecastCodec) {
    ChromecastCodec["H264_BASELINE_LV4_DOT1"] = "avc1.420029";
    ChromecastCodec["H264_BL_LV4_DOT2"] = "avc1.42002a";
    ChromecastCodec["H264_BL_LV5_DOT1"] = "avc1.420033";
    ChromecastCodec["H264_HL_444_INTRA_LV5_DOT0"] = "avc1.f41032";
    ChromecastCodec["H264_HL_444_PRED_LV4_DOT1"] = "avc1.f40028";
    ChromecastCodec["H264_HL_LV4_DOT1"] = "avc1.640028";
    ChromecastCodec["H264_HL_LV4_DOT2"] = "avc1.64002A";
    ChromecastCodec["H265_CODEC"] = "hev1.1.6.L150.B0";
    ChromecastCodec["H265_LV4_DOT0"] = "hev1.2.4.L120.B0";
    ChromecastCodec["VP9_YOUTUBE_8K"] = "vp09.00.51.08.01.01.01.01.00";
})(ChromecastCodec || (ChromecastCodec = {}));
//# sourceMappingURL=chromecast-types.js.map